var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comps)?_c('Histogram',{attrs:{"hcTitle":_vm.hcTitle,"hcSubtitle":_vm.hcSubtitle,"hcData":_vm.HistogramData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }